var render = function() {
  var this$1 = this
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "position: relative;" },
    [
      _c(
        "q-toolbar",
        {
          staticClass: "top-page-toolbar",
          staticStyle: {
            position: "fixed",
            top: "calc(69 + var(--top-offset, 0))px",
            left: "0",
            "z-index": "10",
            "box-shadow":
              "0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)"
          },
          attrs: { color: "white", "text-color": "grey-9" }
        },
        [
          _c("q-toolbar-title"),
          _c(
            "div",
            [
              _c("q-btn", {
                staticClass: "q-mr-md",
                attrs: {
                  label: _vm.$t("preview"),
                  color: "tertiary",
                  flat: ""
                },
                on: { click: _vm.previewQuote }
              }),
              _vm.editing && !_vm.editingDraft
                ? _c(
                    "q-btn",
                    {
                      attrs: { color: "primary" },
                      on: { click: _vm.createQuote }
                    },
                    [_vm._v("\n        " + _vm._s(_vm.$t("save")) + "\n      ")]
                  )
                : _c(
                    "q-btn-dropdown",
                    {
                      attrs: {
                        label: _vm.$t("create"),
                        color: "primary",
                        split: ""
                      },
                      on: { click: _vm.createQuote }
                    },
                    [
                      _c(
                        "q-list",
                        { attrs: { link: "" } },
                        [
                          _c(
                            "q-item",
                            {
                              directives: [
                                {
                                  name: "close-overlay",
                                  rawName: "v-close-overlay"
                                }
                              ]
                            },
                            [
                              _c(
                                "q-item-main",
                                [
                                  _c(
                                    "q-item-tile",
                                    {
                                      attrs: { label: "" },
                                      nativeOn: {
                                        click: function($event) {
                                          return _vm.saveDraft($event)
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(_vm.$t("save_draft")) +
                                          "\n            "
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
            ],
            1
          )
        ],
        1
      ),
      _c("div", { staticClass: "layout-padding" }, [
        _c("section", { staticClass: "invoicing-create" }, [
          _c("header", [
            _vm.activeTeam.settings.logo_url
              ? _c("img", {
                  staticClass: "logo",
                  attrs: { src: _vm.activeTeam.settings.logo_url }
                })
              : _vm._e(),
            _c("span", {
              staticClass: "return-line",
              domProps: { innerHTML: _vm._s(_vm.returnLine) }
            }),
            _c(
              "div",
              { staticClass: "customer" },
              [
                _c("customer-select", {
                  attrs: {
                    hasError: _vm.errors.has("customer"),
                    value: _vm.customer,
                    types: _vm.customerTypes.ALL,
                    errorLabel: _vm.errors.first("customer"),
                    "inverted-light": "",
                    "hide-underline": ""
                  },
                  on: { input: _vm.handleCustomerSelect }
                }),
                _vm.customer && _vm.customer.type === _vm.customerTypes.COMPANY
                  ? _c("customer-select", {
                      staticClass: "q-mt-sm",
                      attrs: {
                        types: [_vm.customerTypes.CONTACT_PERSON],
                        placeholder: _vm.$tc("contact_person", 1),
                        companyFilter: _vm.customerId,
                        hasErrors: _vm.errors.has("contactPerson"),
                        errorLabel: _vm.errors.first("contactPerson")
                      },
                      model: {
                        value: _vm.contactPerson,
                        callback: function($$v) {
                          _vm.contactPerson = $$v
                        },
                        expression: "contactPerson"
                      }
                    })
                  : _vm._e(),
                _vm.customer
                  ? _c("customer-address-select", {
                      staticClass: "q-mt-lg",
                      attrs: { customer: _vm.customer },
                      on: { reFetchCustomer: _vm.handleReFetchCustomer },
                      model: {
                        value: _vm.address,
                        callback: function($$v) {
                          _vm.address = $$v
                        },
                        expression: "address"
                      }
                    })
                  : _vm._e()
              ],
              1
            )
          ]),
          _c(
            "main",
            [
              _c("div", { staticClass: "row items-end" }, [
                _c(
                  "div",
                  { staticClass: "invoice-title" },
                  [
                    _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !_vm.editTitle,
                            expression: "!editTitle"
                          }
                        ],
                        staticClass: "headline q-my-none",
                        on: { click: _vm.toggleQuoteTitle }
                      },
                      [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.quoteTitle) +
                            "\n            "
                        )
                      ]
                    ),
                    _c(
                      "q-field",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.editTitle,
                            expression: "editTitle"
                          }
                        ],
                        staticClass: "q-ma-none headline-input",
                        attrs: {
                          error: _vm.errors.has("quote_title"),
                          "error-label": _vm.errors.first("quote_title")
                        }
                      },
                      [
                        _c("q-input", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate.disable",
                              value: "required|max:255",
                              expression: "'required|max:255'",
                              modifiers: { disable: true }
                            }
                          ],
                          ref: "quoteTitleInput",
                          attrs: {
                            "data-vv-as": _vm.$t("title"),
                            placeholder: _vm.$t("title"),
                            disable: !_vm.editTitle,
                            autofocus: "",
                            "hide-underline": ""
                          },
                          on: {
                            blur: _vm.handleBlurQuoteTitle,
                            keydown: function($event) {
                              if (
                                !("button" in $event) &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.handleBlurQuoteTitle($event)
                            }
                          },
                          model: {
                            value: _vm.quoteTitle,
                            callback: function($$v) {
                              _vm.quoteTitle = $$v
                            },
                            expression: "quoteTitle"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "q-tooltip",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !_vm.editTitle,
                            expression: "!editTitle"
                          }
                        ]
                      },
                      [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.$t("click_to_edit")) +
                            "\n            "
                        )
                      ]
                    )
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "invoice-number" },
                  [
                    _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.generateQuoteNumber,
                            expression: "generateQuoteNumber"
                          }
                        ],
                        staticClass: "invoice-number-text",
                        on: { click: _vm.toggleQuoteNumber }
                      },
                      [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.nextQuoteNumber) +
                            "\n            "
                        )
                      ]
                    ),
                    _c(
                      "q-field",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !_vm.generateQuoteNumber,
                            expression: "!generateQuoteNumber"
                          }
                        ],
                        attrs: {
                          error: _vm.errors.has("quote_number"),
                          "error-label": _vm.errors.first("quote_number")
                        }
                      },
                      [
                        _c("q-input", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate.disable",
                              value: "max:255",
                              expression: "'max:255'",
                              modifiers: { disable: true }
                            }
                          ],
                          ref: "quoteNumberInput",
                          attrs: {
                            name: "quote_number",
                            prefix: "#",
                            "data-vv-as": _vm.$t("quote_number"),
                            placeholder: _vm.$t("quote_number"),
                            disable: _vm.generateQuoteNumber,
                            after: [
                              {
                                icon: "cancel",
                                handler: function handler() {
                                  _vm.generateQuoteNumber = true
                                  _vm.quoteNumber = null
                                }
                              }
                            ],
                            autofocus: "",
                            "hide-underline": ""
                          },
                          on: { blur: _vm.checkQuoteNumber },
                          model: {
                            value: _vm.quoteNumber,
                            callback: function($$v) {
                              _vm.quoteNumber = $$v
                            },
                            expression: "quoteNumber"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "q-tooltip",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.generateQuoteNumber,
                            expression: "generateQuoteNumber"
                          }
                        ]
                      },
                      [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.$t("invoice_number_tooltip")) +
                            "\n            "
                        )
                      ]
                    )
                  ],
                  1
                )
              ]),
              _c(
                "div",
                { staticClass: "invoice-meta q-mt-sm" },
                [
                  _c(
                    "q-field",
                    {
                      staticClass: "q-ma-none",
                      attrs: {
                        error: _vm.errors.has("quoteDate"),
                        "error-label": _vm.errors.first("quoteDate"),
                        label: _vm.$t("quote_date"),
                        "label-width": 6
                      }
                    },
                    [
                      _c("q-datetime", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate.disable",
                            value: "required",
                            expression: "'required'",
                            modifiers: { disable: true }
                          }
                        ],
                        attrs: {
                          type: "date",
                          name: "quoteDate",
                          "hide-underline": "",
                          "data-vv-as": _vm.$t("quote_date"),
                          placeholder: _vm.$t("quote_date"),
                          format: _vm.$t("date_format")
                        },
                        model: {
                          value: _vm.quoteDate,
                          callback: function($$v) {
                            _vm.quoteDate = $$v
                          },
                          expression: "quoteDate"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "q-field",
                    {
                      staticClass: "q-ma-none",
                      attrs: {
                        error: _vm.errors.has("validUntil"),
                        "error-label": _vm.errors.first("validUntil"),
                        label: _vm.$t("valid_until"),
                        "label-width": 6
                      }
                    },
                    [
                      _c("q-datetime", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate.disable",
                            value: "required",
                            expression: "'required'",
                            modifiers: { disable: true }
                          }
                        ],
                        attrs: {
                          type: "date",
                          name: "validUntil",
                          "data-vv-as": _vm.$t("valid_until"),
                          placeholder: _vm.$t("valid_until"),
                          format: _vm.$t("date_format"),
                          "hide-underline": ""
                        },
                        model: {
                          value: _vm.validUntil,
                          callback: function($$v) {
                            _vm.validUntil = $$v
                          },
                          expression: "validUntil"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "q-field",
                    {
                      staticClass: "q-ma-none",
                      attrs: { label: _vm.$tc("project", 1), "label-width": 6 }
                    },
                    [
                      _c(
                        "div",
                        [
                          _c("project-indicator", {
                            attrs: {
                              project: _vm.project ? _vm.project : undefined,
                              clickable: ""
                            }
                          }),
                          _c("project-popover", {
                            attrs: {
                              "active-project": _vm.project
                                ? _vm.project
                                : undefined
                            },
                            on: { "select-project": _vm.handleSelectProject }
                          })
                        ],
                        1
                      )
                    ]
                  )
                ],
                1
              ),
              _c("add-textarea-box", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate.disable",
                    value: "max:100000",
                    expression: "'max:100000'",
                    modifiers: { disable: true }
                  }
                ],
                staticClass: "q-mt-xl",
                attrs: {
                  name: "noteTop",
                  placeholder: _vm.$t("note_top"),
                  "additional-box-text": _vm.$t("or_use_template"),
                  useMarkdown: ""
                },
                on: {
                  clicked: function($event) {
                    _vm.$refs.topTemplateModal.open()
                  }
                },
                model: {
                  value: _vm.noteTop,
                  callback: function($$v) {
                    _vm.noteTop = $$v
                  },
                  expression: "noteTop"
                }
              }),
              _vm._l(_vm.items[0].children, function(entry, index) {
                return _c("line-items", {
                  key: index,
                  ref: "itemsTable",
                  refInFor: true,
                  staticClass: "q-mt-xl",
                  attrs: {
                    value: entry,
                    currency: _vm.currency,
                    "show-heading-input": _vm.items[0].children.length > 1,
                    "show-delete-button": _vm.items[0].children.length > 1
                  },
                  on: {
                    deleteBlock: function($event) {
                      _vm.handleDeleteBlock(index)
                    },
                    deleteItem: function(itemIndex) {
                      return _vm.handleDeleteItem(index, itemIndex)
                    },
                    updateGroup: function(value) {
                      return _vm.handleUpdateGroup(index, value)
                    },
                    updateGroupHeading: function(value) {
                      return _vm.handleUpdateGroupHeading(index, value)
                    },
                    update: _vm.handleLineItemUpdate
                  }
                })
              }),
              _c(
                "div",
                { staticClass: "flex justify-center q-mt-lg" },
                [
                  !_vm.showItemForm
                    ? _c(
                        "q-btn-dropdown",
                        {
                          attrs: {
                            label: _vm.$t("new_line_item_button"),
                            color: "primary",
                            split: "",
                            outline: ""
                          },
                          on: { click: _vm.handleAddItemButton }
                        },
                        [
                          _c(
                            "q-list",
                            { attrs: { link: "" } },
                            [
                              _c(
                                "q-item",
                                {
                                  directives: [
                                    {
                                      name: "close-overlay",
                                      rawName: "v-close-overlay"
                                    }
                                  ],
                                  nativeOn: {
                                    click: function($event) {
                                      return _vm.handleAddLineItemsBlock($event)
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "q-item-main",
                                    [
                                      _c(
                                        "q-item-tile",
                                        { attrs: { label: "" } },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.$t("invoice_block_add"))
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _vm.showItemForm
                ? _c("items-list-new-entry", {
                    staticClass: "q-mt-lg",
                    attrs: {
                      currency: _vm.currency,
                      "active-line-item": _vm.activeLineItem,
                      type: "quote"
                    },
                    on: {
                      add: _vm.handleAddItem,
                      update: _vm.handleUpdateItem,
                      cancel: _vm.handleItemFormCancel
                    }
                  })
                : _vm._e(),
              _vm.errors.has("items")
                ? _c("div", { staticClass: "on-right" }, [
                    _c("span", { staticClass: "text-negative" }, [
                      _vm._v(_vm._s(_vm.$t("item_required")))
                    ])
                  ])
                : _vm._e(),
              _c("invoice-price-summary", {
                staticClass: "q-mt-xl",
                attrs: {
                  items: _vm.lineItems,
                  discount: _vm.discount,
                  cashDiscount: _vm.cashDiscount
                }
              }),
              _c(
                "div",
                { staticClass: "row justify-end q-mt-sm q-mb-xl" },
                [
                  _vm.discount === null
                    ? _c(
                        "q-btn",
                        {
                          attrs: {
                            color: "grey-7",
                            flat: "",
                            outline: "",
                            dense: "",
                            "no-caps": ""
                          },
                          on: { click: _vm.addDiscount }
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("add_discount")) +
                              "\n          "
                          )
                        ]
                      )
                    : _c(
                        "q-btn",
                        {
                          attrs: {
                            color: "negative",
                            flat: "",
                            outline: "",
                            dense: "",
                            "no-caps": ""
                          },
                          on: { click: _vm.deleteDiscount }
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("delete_discount")) +
                              "\n          "
                          )
                        ]
                      )
                ],
                1
              ),
              _c("add-textarea-box", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate.disable",
                    value: "max:100000",
                    expression: "'max:100000'",
                    modifiers: { disable: true }
                  }
                ],
                staticClass: "q-mt-xl",
                attrs: {
                  name: "noteBottom",
                  placeholder: _vm.$t("note_bottom"),
                  "additional-box-text": _vm.$t("or_use_template"),
                  useMarkdown: ""
                },
                on: {
                  clicked: function($event) {
                    _vm.$refs.bottomTemplateModal.open()
                  }
                },
                model: {
                  value: _vm.noteBottom,
                  callback: function($$v) {
                    _vm.noteBottom = $$v
                  },
                  expression: "noteBottom"
                }
              })
            ],
            2
          ),
          _c(
            "div",
            { staticClass: "footer" },
            [
              _c("q-collapsible", { attrs: { label: _vm.$t("options") } }, [
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "col-12 col-md-6" },
                    [
                      _c("language-input", {
                        attrs: { labelWidth: 3 },
                        model: {
                          value: _vm.language,
                          callback: function($$v) {
                            _vm.language = $$v
                          },
                          expression: "language"
                        }
                      })
                    ],
                    1
                  )
                ])
              ])
            ],
            1
          )
        ])
      ]),
      _c("text-template-modal", {
        ref: "topTemplateModal",
        attrs: { model: "quote", initialPosition: "top" },
        on: {
          selected: function(text) {
            return (this$1.noteTop = text)
          }
        }
      }),
      _c("text-template-modal", {
        ref: "bottomTemplateModal",
        attrs: { model: "quote", initialPosition: "bottom" },
        on: {
          selected: function(text) {
            return (this$1.noteBottom = text)
          }
        }
      }),
      _c("add-discount-dialog", {
        ref: "addDiscountDialog",
        attrs: { currency: _vm.currency },
        on: { discount: _vm.handleAddDiscount }
      }),
      _c("preview-modal", {
        ref: "previewModal",
        attrs: { blob: _vm.previewBlob }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }